import type { ReportType } from "@prisma/client";

export const REPORT_TYPE: { [key in ReportType]: string } & { PPT: string } = {
  ANNUAL: "Annual",
  INDUSTRY: "Industry",
  LOCALIZED: "Localized",
  MONTHLY: "Monthly Snapshot",
  TOPICS: "Topics",
  OTHER: "Other",
  PPT: "PPT-handouts",
}

export const REPORT_TYPE_OPTIONS: (
  | { value: ReportType; label: string; isPublic: boolean }
  | { value: "PPT"; label: string; isPublic: boolean }
)[] = [
  { value: "ANNUAL", label: REPORT_TYPE.ANNUAL, isPublic: true },
  { value: "INDUSTRY", label: REPORT_TYPE.INDUSTRY, isPublic: true },
  { value: "LOCALIZED", label: REPORT_TYPE.LOCALIZED, isPublic: true },
  { value: "MONTHLY", label: REPORT_TYPE.MONTHLY, isPublic: true },
  { value: "TOPICS", label: REPORT_TYPE.TOPICS, isPublic: true },
  { value: "OTHER", label: REPORT_TYPE.OTHER, isPublic: false },
  // Custom Filter option - not actually actually a report type but a way for users to select reports with PPTs
  { value: "PPT", label: REPORT_TYPE.PPT, isPublic: true },
]
